import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import i18n from '@/i18n';
import { adminUserApi, type CreateAdminUserInput } from '../api/adminUser.api';
import { adminUserKeys } from '../api/adminUser.keys';

export function useAdminUserList(params: any) {
  return useQuery({
    queryKey: adminUserKeys.list(params),
    queryFn: () => adminUserApi.list(params),
    placeholderData: keepPreviousData,
  });
}

export function useCreateAdminUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateAdminUserInput) => adminUserApi.create(input),
    onSuccess: () => {
      toast.success(i18n.t('adminUsers.toast.created'));
      qc.invalidateQueries({ queryKey: adminUserKeys.lists() });
    },
    onError: (err: any) => {
      toast.error(err?.response?.data?.message ?? i18n.t('adminUsers.toast.createFailed'));
    },
  });
}

export function useDeleteAdminUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => adminUserApi.delete(id),
    onSuccess: () => {
      toast.success(i18n.t('adminUsers.toast.deleted'));
      qc.invalidateQueries({ queryKey: adminUserKeys.lists() });
    },
    onError: (err: any) => {
      toast.error(err?.response?.data?.message ?? i18n.t('adminUsers.toast.deleteFailed'));
    },
  });
}
